var _defs, _rect, _g, _text, _text2, _text3, _g2, _rect2, _text4, _rect3, _text5, _g3, _text6, _g4, _text7, _rect4, _text8, _text9, _text10, _rect5, _text11, _text12, _text13, _g5, _text14, _g6, _rect6, _text15, _rect7, _text16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchitectureAutoscale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 600",
    fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "gBlue",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 4.5,
    floodColor: "#3b82f6",
    floodOpacity: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gGreen",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 4.5,
    floodColor: "#22c55e",
    floodOpacity: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gIndigo",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 4.5,
    floodColor: "#6366f1",
    floodOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flow",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec4899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b82f6"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "fArrow",
    markerWidth: 9,
    markerHeight: 9,
    refX: 6,
    refY: 3.5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L7 3.5 L0 7 Z",
    fill: "#3b82f6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "i-play",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 4 19 12 7 20Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "i-git",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8.5v7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10.5c0 4-4 5-6 5.5"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "i-server",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 7,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13,
    width: 18,
    height: 7,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7.5h.01M7 16.5h.01"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "i-check",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12 11 15 16 9"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "i-bolt",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 2 4 14h7l-1 8 10-13h-8z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "i-down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11 12 15 16 11"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "i-flag",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 21V4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h12l-2 4 2 4H5"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 960,
    height: 600,
    fill: "#0a0f1e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#1b2942",
    fill: "none",
    strokeWidth: 1,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 80,
    rx: 70,
    ry: 46
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 80,
    rx: 135,
    ry: 90
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 80,
    rx: 205,
    ry: 136
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 850,
    cy: 540,
    rx: 70,
    ry: 46
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 850,
    cy: 540,
    rx: 135,
    ry: 90
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 850,
    cy: 540,
    rx: 205,
    ry: 136
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 40,
    fontSize: 15,
    fontWeight: 700,
    fill: "#e6edfb"
  }, "Auto-Scaling Flow")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 60,
    fontSize: 12,
    fill: "#7e8db0"
  }, "Capacity follows your workload. You never manage nodes.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 92,
    fontFamily: "'JetBrains Mono','SFMono-Regular',Consolas,monospace",
    fontSize: 10.5,
    letterSpacing: 2,
    fill: "#5f79b0"
  }, "TRIGGER")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#gBlue)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 100,
    width: 880,
    height: 92,
    rx: 14,
    fill: "#0d1730",
    stroke: "#3b82f6",
    strokeWidth: 1.5,
    strokeDasharray: "7 6"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 122,
    width: 270,
    height: 48,
    rx: 10,
    fill: "#101c36",
    stroke: "#28375a"
  })), /*#__PURE__*/React.createElement("use", {
    href: "#i-play",
    x: 198,
    y: 138,
    width: 16,
    height: 16,
    style: {
      color: "#60a5fa"
    }
  }), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 224,
    y: 151,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#dbe4f7"
  }, "Submit a one-off job")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 122,
    width: 270,
    height: 48,
    rx: 10,
    fill: "#101c36",
    stroke: "#28375a"
  })), /*#__PURE__*/React.createElement("use", {
    href: "#i-git",
    x: 528,
    y: 138,
    width: 16,
    height: 16,
    style: {
      color: "#c084fc"
    }
  }), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 554,
    y: 151,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#dbe4f7"
  }, "Push to an automation branch")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#flow)",
    strokeWidth: 2.5,
    markerEnd: "url(#fArrow)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 196,
    x2: 300,
    y2: 224
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 196,
    x2: 480,
    y2: 224
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 196,
    x2: 660,
    y2: 224
  }))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 252,
    fontFamily: "'JetBrains Mono','SFMono-Regular',Consolas,monospace",
    fontSize: 10.5,
    letterSpacing: 2,
    fill: "#57b98a"
  }, "YOUR DEDICATED CLUSTER / CAPACITY CHECK")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#gGreen)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 260,
    width: 880,
    height: 150,
    rx: 14,
    fill: "#0b1a16",
    stroke: "#22c55e",
    strokeWidth: 1.5,
    strokeDasharray: "7 6"
  }))), /*#__PURE__*/React.createElement("use", {
    href: "#i-server",
    x: 64,
    y: 280,
    width: 18,
    height: 18,
    style: {
      color: "#4ade80"
    }
  }), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 294,
    fontSize: 12,
    fill: "#a7c9b6"
  }, "Workload enters your cluster, inside your private VPC, on dedicated nodes.")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 312,
    width: 410,
    height: 78,
    rx: 10,
    fill: "#0e1c17",
    stroke: "#1f4d38"
  })), /*#__PURE__*/React.createElement("use", {
    href: "#i-check",
    x: 84,
    y: 340,
    width: 20,
    height: 20,
    style: {
      color: "#4ade80"
    }
  }), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 342,
    fontSize: 12.5,
    fontWeight: 700,
    fill: "#e2f3ea"
  }, "Capacity free")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 360,
    fontSize: 11,
    fill: "#8fbfa5"
  }, "Runs immediately, no wait.")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 376,
    fontSize: 11,
    fill: "#8fbfa5"
  }, "Your fast path.")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 486,
    y: 312,
    width: 410,
    height: 78,
    rx: 10,
    fill: "#1c160a",
    stroke: "#5a4413"
  })), /*#__PURE__*/React.createElement("use", {
    href: "#i-bolt",
    x: 506,
    y: 340,
    width: 20,
    height: 20,
    style: {
      color: "#fbbf24"
    }
  }), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 538,
    y: 342,
    fontSize: 12.5,
    fontWeight: 700,
    fill: "#f6e6c4"
  }, "Cluster busy")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 538,
    y: 360,
    fontSize: 11,
    fill: "#c9a869"
  }, "Scales up: a new node joins in 2-3 min,")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 538,
    y: 376,
    fontSize: 11,
    fill: "#c9a869"
  }, "then your workload runs.")), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#flow)",
    strokeWidth: 2.5,
    markerEnd: "url(#fArrow)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 414,
    x2: 300,
    y2: 442
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 414,
    x2: 480,
    y2: 442
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 414,
    x2: 660,
    y2: 442
  }))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 470,
    fontFamily: "'JetBrains Mono','SFMono-Regular',Consolas,monospace",
    fontSize: 10.5,
    letterSpacing: 2,
    fill: "#7d84f0"
  }, "LIFECYCLE / SCALE TO ZERO")), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#gIndigo)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 478,
    width: 880,
    height: 92,
    rx: 14,
    fill: "#10122b",
    stroke: "#6366f1",
    strokeWidth: 1.5,
    strokeDasharray: "7 6"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 500,
    width: 410,
    height: 48,
    rx: 10,
    fill: "#141833",
    stroke: "#2e356a"
  })), /*#__PURE__*/React.createElement("use", {
    href: "#i-flag",
    x: 84,
    y: 516,
    width: 16,
    height: 16,
    style: {
      color: "#a5b4fc"
    }
  }), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 529,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#dfe3fb"
  }, "Job / build completes, resources freed")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 486,
    y: 500,
    width: 410,
    height: 48,
    rx: 10,
    fill: "#141833",
    stroke: "#2e356a"
  })), /*#__PURE__*/React.createElement("use", {
    href: "#i-down",
    x: 506,
    y: 516,
    width: 16,
    height: 16,
    style: {
      color: "#a5b4fc"
    }
  }), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 532,
    y: 529,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#dfe3fb"
  }, "Idle 3-5 min: cluster scales down, you save cost")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchitectureAutoscale);
export default __webpack_public_path__ + "static/media/architecture-autoscale.de8d114f204453edb50d4c0e28abcbf1.svg";
export { ForwardRef as ReactComponent };